export default class ColorPicker {
	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT ColorPicker');
		$('.dp-color-picker-field').wpColorPicker();
	}
}
